module.exports = __webpack_public_path__ + "img/article_ad_banner_01.860ff5b2.jpg";